import React from 'react'

import CTA from '@f/elements/CTA'

const MapFiltersBar = props => {
  let filters = []

  for (let filter in props.params) {
    const name = filter.split('__')[0]

    let currentFilter = props.availableFilters.find(
      filter => filter.name == name
    )
    let currentValue

    if (!currentFilter) {
      continue
    }

    const filtersToCheck = props.params[filter].split(',')

    if (filtersToCheck.length > 1) {
      filters.push({
        id: currentFilter.label,
        value: `${currentFilter.labelPlural} · ${filtersToCheck.length}`,
        name: filter
      })
    } else {
      filtersToCheck.map(value => {
        currentValue =
          (currentFilter &&
            currentFilter.values &&
            currentFilter.values.find(filterValue => filterValue.id == value) &&
            currentFilter.values.find(filterValue => filterValue.id == value)
              .name) ||
          value

        let displayValue = currentValue

        filters.push({
          id: value,
          value: displayValue,
          name: filter
        })
      })
    }
  }

  filters = filters.filter(filter => filter.value)

  if (props.locationParams.label) {
    filters.push({
      id: props.locationParams.label,
      value: `Ort: ${props.locationParams.label}`,
      name: 'office_location'
    })
  }

  return props.availableFilters.map(currentMainFilter => {
    const activeFilter = filters.find(
      filter => filter.name.indexOf(currentMainFilter.name) > -1
    )

    const isActive = !!activeFilter

    let styles = {}
    let dataSel = ''
    switch (currentMainFilter.name) {
      case 'construction_methods':
        styles = {
          maxWidth: 120
        }
        dataSel = 'btn-flt-cm'
        break
      case 'expansion_stages':
        styles = {
          maxWidth: 120
        }
        dataSel = 'btn-flt-exp'
        break
      case 'vendor_nid':
        dataSel = 'btn-flt-vdr'
        break
      case 'office_location':
        dataSel = 'btn-flt-bo'
        break
    }

    return (
      <CTA
        key={`main_filter_${currentMainFilter.name}`}
        type='block-tertiary'
        tag='button'
        className={`[ f-p-a-010 f-m-a-005 ] SearchResultsFilters-button ${
          isActive ? 'is-active' : ''
        } ${
          props.panelDisplayed?.filter === currentMainFilter.name
            ? 'has-panel-displayed'
            : ''
        }`}
        data-sel={dataSel}
        onClick={event =>
          props?.displayPanel({
            filter: currentMainFilter.name,
            offsetLeft: event.currentTarget.offsetLeft,
            isActive
          })
        }
        wtData={{
          'CTA-click': {
            label: 'filter-type',
            location: 'filter-panel'
          }
        }}
        style={isActive ? styles : null}>
        <span className='[ f-d-bl f-p-h-005 f-t-ellip ]'>
          {isActive ? activeFilter.value : currentMainFilter.label}
        </span>
      </CTA>
    )
  })
}

export default MapFiltersBar
